export default __webpack_public_path__ + "static/california-logo-e1098ae81ade1216eb4b2e3af9e97411.svg";